import axios from "axios";
import { SERVER_URL } from "../config/config";

class ReportServices {
  private static serverURL = SERVER_URL;

  public static async getCLEAttendanceReportBeforeEvent(eventId: number, location?: string) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    let apiUrl = `${this.serverURL}/api/event/report/seminar/attendance-report/before?EventId=${eventId}`;
    if (location && location !== "") {
      apiUrl += `&Location=${encodeURIComponent(location)}`;
    }
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getCLEAttendanceReportAfterEvent(eventId: number, location?: string) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    let apiUrl = `${this.serverURL}/api/event/report/seminar/attendance-report/after?EventId=${eventId}`;
    if (location && location !== "") {
      apiUrl += `&Location=${encodeURIComponent(location)}`;
    }
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getFuncAttendanceReportBeforeEvent(eventId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/event/report/function/attendance-report/before?EventId=${eventId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getFuncAttendanceReportAfterEvent(eventId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/event/report/function/attendance-report/after?EventId=${eventId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getCommissionReport(eventType: string, eventId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

    const apiUrl = `${this.serverURL}/api/event/report/commision-report?EventType=${eventType}&EventId=${eventId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("setCommissionReport", response);
    return response;
  }

  public static async fetchMembershipData(fromDate: string, toDate: string) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

    const apiUrl = `${this.serverURL}/api/admin/membership-accounting-summary?fromDate=${fromDate}&toDate=${toDate}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("fetchMembershipData", response);
    return response;
  }

  public static async fetchAdvanceMemberCodeReport(pageNum = 1, limitNum = 20) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

  const apiUrl = `${this.serverURL}/api/admin/advance-member-code-report?page=${pageNum}&limit=${limitNum}`;
  const response = await axios.get(apiUrl, axiosConfig);
  console.log("fetchMembershipData", response);
  return response;
};

public static async fetchAdvanceMemberCodeReportForPrint() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      ApiKey: process.env.REACT_APP_API_KEY,
      SessionToken: sessionStorage.getItem("DsbaAdminToken"),
    },
  };
  const apiUrl = `${this.serverURL}/api/admin/advance-member-code-report/print`;
  try {
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("fetchAdvanceMemberCodeReportForPrint", response);
    return response;
  } catch (error) {
    console.error("Error in fetchAdvanceMemberCodeReportForPrint", error);
    throw error;
  }
}

public static async fetchMembershipPendingPaymentReport(pageNum = 1, limitNum = 20) {
  let axiosConfig = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      ApiKey: process.env.REACT_APP_API_KEY,
      SessionToken: sessionStorage.getItem("DsbaAdminToken"),
    },
  };

  const apiUrl = `${this.serverURL}/api/admin/membership-pending-payment-report?page=${pageNum}&limit=${limitNum}`;
  const response = await axios.get(apiUrl, axiosConfig);
  console.log("fetchMembershipData", response);
  return response;
};

  public static async fetchMembershipPendingPaymentReportForPrint() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    const apiUrl = `${this.serverURL}/api/admin/membership-pending-payment-report/print`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("fetchMembershipPendingPaymentReportForPrint", response);
    return response;
  }

  public static async downloadExcel() {
    try {
      const response = await axios.get(
        `${this.serverURL}/api/admin/membership-pending-payment-report/print`,
        {
          headers: {
            'Content-Type': 'application/json',
            'ApiKey': process.env.REACT_APP_API_KEY,
            'SessionToken': sessionStorage.getItem('DsbaAdminToken') || '',
          },
          responseType: 'blob', // Important for file downloads
        }
      );
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `pending_payments_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // Handle error
    }
  }

  public static async downloadExcelForMemberCodeAdvancement() {
    try {
      const response = await axios.get(
        `${this.serverURL}/api/admin/advance-member-code-report/print`,
        {
          headers: {
            'Content-Type': 'application/json',
            'ApiKey': process.env.REACT_APP_API_KEY,
            'SessionToken': sessionStorage.getItem('DsbaAdminToken') || '',
          },
          responseType: 'blob', // Important for file downloads
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `member_code_advancement_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // Handle error
    }
  }

  public static async downloadAssociateMembersTab() {
    try {
      const response = await axios.get(
        `${this.serverURL}/api/member/export-associate-members`,
        {
          headers: {
            'Content-Type': 'application/json',
            'ApiKey': process.env.REACT_APP_API_KEY,
            'SessionToken': sessionStorage.getItem('DsbaAdminToken') || '',
          },
          responseType: 'blob', // Important for file downloads
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'associate-members.tab');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  }

  public static async downloadMemberDirectoryTab() {
    try {
      const response = await axios.get(
        `${this.serverURL}/api/member/export-member-directory`,
        {
          headers: {
            'Content-Type': 'application/json',
            'ApiKey': process.env.REACT_APP_API_KEY,
            'SessionToken': sessionStorage.getItem('DsbaAdminToken') || '',
          },
          responseType: 'blob', // Important for file downloads
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'member-directory.tab');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  }

  public static async downloadFirmsTab() {
    try {
      const response = await axios.get(
        `${this.serverURL}/api/member/export-firms`,
        {
          headers: {
            'Content-Type': 'application/json',
            'ApiKey': process.env.REACT_APP_API_KEY,
            'SessionToken': sessionStorage.getItem('DsbaAdminToken') || '',
          },
          responseType: 'blob', // Important for file downloads
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'firms.tab');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  }

  public static async fetchJobData() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

    const apiUrl = `${this.serverURL}/api/admin/job-tracking`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("fetchJobData", response);
    return response;
  }

  public static async runVideoJob(jobId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

    const apiUrl = `${this.serverURL}/api/admin/sync-files`;
    const response = await axios.post(apiUrl, {}, axiosConfig);
    console.log("runJob", response);
    return response;
  }

  public static async runMembershipJob(jobId: string) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

    const apiUrl = `${this.serverURL}/api/order/bulkmembership`;
    const response = await axios.post(apiUrl, jobId, axiosConfig);
    console.log("runJob", response);
    return response;
  }

  public static async sendReminderEmail() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };

    const apiUrl = `${this.serverURL}/api/order/send-membership-reminder-email`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("runJob", response);
    return response;
  }

}

export default ReportServices;
